/**
 * Custom Variant Swatch Handler
 * Manages interactions for custom variant swatches with metafields
 */

class CustomVariantSwatches {
  constructor() {
    this.init();
  }

  init() {
    // Listen for changes on custom swatch inputs
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('custom-swatch-input')) {
        this.handleSwatchChange(e.target);
      }
    });

    // Listen for clicks on swatch containers
    document.addEventListener('click', (e) => {
      const swatchContainer = e.target.closest('.custom-swatch-container');
      if (swatchContainer && !swatchContainer.classList.contains('disabled')) {
        const input = swatchContainer.querySelector('.custom-swatch-input');
        if (input && !input.checked) {
          input.click();
        }
      }
    });
  }

  handleSwatchChange(input) {
    // Remove selected class from all swatches in the same group
    const fieldset = input.closest('fieldset');
    if (fieldset) {
      const allSwatches = fieldset.querySelectorAll('.custom-swatch-container');
      allSwatches.forEach(swatch => {
        swatch.classList.remove('selected');
      });

      // Add selected class to the clicked swatch
      const selectedSwatch = input.closest('.custom-swatch-container');
      if (selectedSwatch) {
        selectedSwatch.classList.add('selected');
      }

      // Update the selected value display in the legend
      const selectedValueSpan = fieldset.querySelector('[data-selected-value]');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
    }

    // Trigger variant change event for Shopify's variant selects
    this.triggerVariantChange(input);
  }

  triggerVariantChange(input) {
    // This ensures compatibility with Shopify's variant-selects component
    const form = input.form;
    if (form) {
      const changeEvent = new Event('change', { bubbles: true });
      input.dispatchEvent(changeEvent);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomVariantSwatches();
  });
} else {
  new CustomVariantSwatches();
}